import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { MdBrokenImage, MdPerson } from "react-icons/md";

const FALLBACK_ICONS = {
  image: MdBrokenImage,
  avatar: MdPerson,
};

const ImageWithPlaceholder = ({
  src,
  placeholder,
  alt,
  className,
  height,
  width,
  fallback = "image",
  style,
}) => {
  const [status, setStatus] = useState(src ? "loading" : "error");

  useEffect(() => {
    setStatus(src ? "loading" : "error");
  }, [src]);

  const numericHeight = typeof height === "number" ? height : 200;
  const numericWidth = typeof width === "number" ? width : 200;
  const iconSize = Math.max(
    16,
    Math.min(48, Math.floor(Math.min(numericHeight, numericWidth) * 0.2))
  );
  const FallbackIcon = FALLBACK_ICONS[fallback] || FALLBACK_ICONS.image;

  const containerStyle = {
    position: "relative",
    height,
    width,
    overflow: "hidden",
    backgroundColor: "#e9ecef",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...style,
  };

  return (
    <div className={className} style={containerStyle}>
      {status === "loading" && (
        <Spinner
          animation="border"
          size="sm"
          role="status"
          style={{ position: "absolute", zIndex: 1 }}
        />
      )}

      {status === "error" &&
        (placeholder ? (
          <img
            src={placeholder}
            alt="fallback"
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <FallbackIcon
            size={iconSize}
            color="#adb5bd"
            aria-label={fallback === "avatar" ? "Avatar unavailable" : "Image unavailable"}
          />
        ))}

      {src && status !== "error" && (
        <img
          src={src}
          alt={alt}
          height={height}
          width={width}
          loading="lazy"
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
            visibility: status === "loaded" ? "visible" : "hidden",
          }}
          onLoad={() => setStatus("loaded")}
          onError={() => setStatus("error")}
        />
      )}
    </div>
  );
};

export default ImageWithPlaceholder;
